import React from 'react';

interface FraseProps {
    children: string;
    className?: string;
    /**
     * Marca que busca GSAP. Por defecto `palabra`; se puede cambiar si en una
     * misma sección conviven dos frases que deben entrar en momentos distintos.
     */
    marca?: string;
    as?: 'span' | 'p';
}

/**
 * Parte una frase en palabras, cada una dentro de su propia caja recortada,
 * para que GSAP pueda hacerlas subir escalonadas desde detrás del renglón.
 *
 * Por qué a mano y no con SplitText: SplitText es plugin de pago de GreenSock.
 * Partir por palabras en el marcado da el 90 % del efecto, gratis, y además
 * llega ya partido en el HTML — no hay un parpadeo entre el texto plano y el
 * texto troceado cuando GSAP termina de cargar.
 *
 * Tres cuidados que parecen tonterías y no lo son:
 * - `overflow: hidden` recorta la caja de cada palabra, así que sin el
 *   padding/margen negativo se comería la «g» de «negocio» y los acentos.
 * - El espacio va FUERA de la caja recortada, y es un espacio normal:
 *   dentro se recortaria, y como espacio duro la frase no partiria de renglon.
 * - Si GSAP nunca llega, esto se ve exactamente igual que un `<span>` normal.
 *   El movimiento se añade encima de algo que ya está bien.
 */
const Frase: React.FC<FraseProps> = ({ children, className, marca = 'palabra', as = 'span' }) => {
    const Tag = as;
    const palabras = children.split(' ');

    return (
        <Tag className={className}>
            {palabras.map((palabra, i) => (
                <React.Fragment key={`${palabra}-${i}`}>
                    <span className="-my-[0.14em] inline-block overflow-hidden py-[0.14em] align-bottom">
                        <span data-frase={marca} className="inline-block">
                            {palabra}
                        </span>
                    </span>
                    {i < palabras.length - 1 && ' '}
                </React.Fragment>
            ))}
        </Tag>
    );
};

export default Frase;
